export default "__VITE_ASSET__BiRz2eDe__"